import React, { Component } from 'react';
import Plyr from './player';

class VideoPlayerView extends Component {
  componentWillUnmount() {
    // Cleanup: stop the player if it exists
    if (this.plyr && this.plyr.player) {
      try {
        this.plyr.player.pause();
      } catch (error) {
        // Ignore errors during cleanup
      }
    }
  }

  render() {
    // const { videoId } = this.props;

    if (this.props.videoUrl === null || this.props.videoId === '0') {
      return <div className="player-container" />;
    }

    return (
      <div className="player-container">
        <Plyr
          className="player-view"
          videoId={this.props.videoUrl}
          url={this.props.videoUrl}
          provider={'vimeo'}
          ref={(plyr) => (this.plyr = plyr)}
        />
      </div>
    );
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.videoId !== prevProps.videoId) {
  //     if (this.plyr) {
  //       console.log('reload plyr');
  //       //  this.plyr.stop();
  //       //this.plyr.forceUpdate();
  //     }
  //   }
  // }
}

VideoPlayerView.defaultProps = {
  videoId: '0',
  videoUrl: null,
};

export default VideoPlayerView;
